// SETTINGS V2 atom — SSaveBtn. Primary save button in the module accent.
// Port of settings-kit.jsx SSaveBtn (lines 122-124). i18n-agnostic — the caller
// passes the label (atoms never call translate).
import React from "react";

export interface SSaveBtnProps {
  enabled: boolean;
  onClick?: () => void;
  label?: string;
  busy?: boolean;
  /** SP2 §5.2 — allow a submit button that links to a form by id, so the save
   *  action can live in the SCard header slot (outside the <form>) and still
   *  submit via the `form` attribute (Enter-in-field parity). Default "button". */
  type?: "button" | "submit";
  form?: string;
}

const SSaveBtn: React.FC<SSaveBtnProps> = ({
  enabled,
  onClick,
  label,
  busy,
  type = "button",
  form,
}) => (
  <button
    type={type}
    form={form}
    className="btn btn-primary"
    onClick={onClick}
    disabled={!enabled || busy}
    style={{
      background: "var(--mod-accent)",
      borderColor: "var(--mod-accent)",
      opacity: enabled ? 1 : 0.4,
      whiteSpace: "nowrap",
    }}
  >
    {label}
  </button>
);

export default SSaveBtn;
